import domReady from '@wordpress/dom-ready';
import { render } from '@wordpress/element';
import Slider from 'react-slick';

const App = ( { attributes } ) => {
	const { 
        images, 
        slidesToShow, 
        slidesArrowShow, 
        slidesDotsShow,
		alignment,
		testimonialItems

    } =
		attributes;

	const settings = {
		dots: slidesDotsShow,
		arrows: slidesArrowShow,
		infinite: true,
		speed: 1000,
		slidesToShow,
		slidesToScroll: 1,
		accessibility: true,
        centerPadding: '60px',
        prevArrow: <button type="button"><svg xmlns="http://www.w3.org/2000/svg" width="33" height="22" viewBox="0 0 33 22" fill="none">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M0.50064 11.1529L0.500741 11.1626C0.505761 11.6453 0.704306 12.1073 1.05452 12.4513L9.7655 20.86C10.4976 21.5666 11.6579 21.5661 12.3893 20.8587V20.8587C13.1558 20.1174 13.1567 18.8889 12.3913 18.1464L7.05777 12.9726L30.651 12.9726C31.6722 12.9726 32.5 12.1448 32.5 11.1236V11.1236C32.5 10.1024 31.6722 9.27461 30.651 9.27461L7.0652 9.27461L12.3909 4.10833C13.1565 3.36564 13.1556 2.13671 12.3889 1.39517V1.39517C11.6574 0.687749 10.497 0.687003 9.76467 1.39348L1.05417 9.7962C0.873649 9.97345 0.731821 10.1834 0.636985 10.4133C0.541496 10.6447 0.494988 10.8929 0.500427 11.1431L0.50064 11.1529Z" fill="#A4BBD8"/>
	  </svg></button>,
        nextArrow: <button type="button"><svg xmlns="http://www.w3.org/2000/svg" width="33" height="22" viewBox="0 0 33 22" fill="none">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M32.4994 11.101L32.4993 11.0913C32.4942 10.6086 32.2957 10.1466 31.9455 9.80257L23.2345 1.39392C22.5024 0.687261 21.3421 0.687818 20.6107 1.39518C19.8442 2.13649 19.8433 3.36503 20.6087 4.10748L25.9422 9.28133L2.34899 9.28133C1.32782 9.28133 0.5 10.1091 0.5 11.1303C0.5 12.1515 1.32782 12.9793 2.34898 12.9793L25.9348 12.9793L20.6091 18.1456C19.8435 18.8883 19.8444 20.1172 20.6111 20.8587C21.3426 21.5662 22.503 21.5669 23.2353 20.8604L31.9458 12.4577C32.1264 12.2805 32.2682 12.0705 32.363 11.8407C32.4585 11.6092 32.505 11.3611 32.4996 11.1108L32.4994 11.101Z" fill="#A4BBD8"/>
	  </svg></button>,
		responsive: [
			{
				breakpoint: 767,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	};

	const alignmentStyle = {
		textAlign: alignment	
	}

	return (
		<Slider { ...settings }>
			{ testimonialItems &&
				testimonialItems?.map( ( testimonial ) => (
					<div className='testimonial-item' key={testimonial.id}>
                        <p>{testimonial.descText}</p>
                        <div className='testimonial-footer'>
							<img src={testimonial.image.url} atl={testimonial.image.title} width="80"/>
                            <div className='author-info'>
								<h4>{testimonial.authorText}</h4>
								{
									testimonial.companyName && (
										<h5>{testimonial.companyName}</h5>
									)
								}
							</div>
                        </div>
                    </div>
				) ) }
		</Slider>
	);
};

domReady( () => {
	const mountWrap = document.querySelector(
		'.wp-block-wedocs-gblocks-testimonial'
	);

	render(
		<App
			attributes={ JSON.parse(
				mountWrap.getAttribute( 'data-attributes' )
			) }
		/>,
		mountWrap
	);
} );
